import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CookieConsentComponent } from '@components';
import { DesktopDirective, MobileDirective } from '@directives';
import { ContentService, GknFooter } from '@services';
import { Observable, filter, map } from 'rxjs';

@Component({
    selector: 'app-footer-brand-copyright',
    imports: [
        CommonModule,
        DesktopDirective,
        MobileDirective,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatCardModule,
        CookieConsentComponent,
    ],
    templateUrl: './app-footer-brand-copyright.component.html',
    styleUrls: ['./app-footer-brand-copyright.component.scss'],
})
export class AppFooterBrandCopyrightComponent implements OnInit {
    private contentService = inject(ContentService);

    currentYear: number = new Date().getFullYear();
    genesysUrl = 'https://genesys.com';
    privacyPolicy$: Observable<GknFooter>;
    termsOfUse$: Observable<GknFooter>;

    ngOnInit(): void {
        this.privacyPolicy$ = this.contentService.footers$.pipe(
            map((footers: GknFooter[]) => footers.find((f: GknFooter) => f.type == 'privacy_policy')),
            filter((privacyPolicy) => !!privacyPolicy),
        );

        this.termsOfUse$ = this.contentService.footers$.pipe(
            map((footers: GknFooter[]) => footers.find((f: GknFooter) => f.type == 'terms_of_use')),
            filter((termsOfUse) => !!termsOfUse),
        );
    }

    // /**
    //  * Triggers the Qualtrics feedback survey intercept
    //  * DOES NOT WORK. Qualtrics provides its own feedback button via the injector, but it just puts the button in a different place than the footer like we'd hoped.
    //  */
    // handleFeedbackFormDialog() {
    //     const QSI = (window as any).QSI;
    //
    //     if (QSI?.API) {
    //         QSI.API.unload();
    //         QSI.API.load().then(() => {
    //             QSI.API.run();
    //         });
    //     } else {
    //         console.debug('[QualtricsFeedback] QSI.API not available');
    //     }
    // }
}
